<div class="custom-dialog">
<div class="header">
    <span>Project Details</span>
    <span class="close" (click)="onCancel()">x</span>
</div>
<div *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</div>
<mat-form-field [class.error]="showError && (!project.projectName || duplicateNameFound)">
    <mat-label>Project Name</mat-label>
    <input matInput type="text" [(ngModel)]="project.projectName" autocomplete="off">    
</mat-form-field>
<mat-form-field>    
    <mat-label>Job Info</mat-label>
    <input matInput type="text" [(ngModel)]="project.jobInfo" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>GC</mat-label>
    <input matInput type="text" [(ngModel)]="project.gc" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>Contractor</mat-label>
    <input matInput type="text" [(ngModel)]="project.contractor" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>Architect</mat-label>
    <input matInput type="text" [(ngModel)]="project.architect" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>Architect Project Number</mat-label>
    <input matInput type="text" [(ngModel)]="project.architectProjectNumber" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>Distributor</mat-label>
    <input matInput type="text" [(ngModel)]="project.distributor" autocomplete="off">    
</mat-form-field>
<mat-form-field>
    <mat-label>Project Address</mat-label>
    <input matInput type="text" [(ngModel)]="project.projectAddress" autocomplete="off">    
</mat-form-field>
<app-checkbox text="Use Cover Page" [(ngModel)]="project.useCoverPage" class="cover-page"></app-checkbox>

<div class="footer">
    <app-button (onClick)="onSave()" [label]="buttonText" class="save-btn" className="primary-alt" [showSpinner]="showSpinner"></app-button>
    <app-button (onClick)="onCancel()" label="Cancel" class="cancel-btn" className="secondary-alt"></app-button>
</div>
</div>